import React, { FC } from 'react';
import { QuestionnaireForm } from './QuestionnaireForm';
import { QuestionnaireDocumentDownload } from './QuestionnaireDocumentDownload';
import { Attachment } from '../../../../interfaces/Attachment';

interface Props {
  attachments: Attachment[];
  operationId: string;
  emailReceiver: string;
  onDocumentAction?: (type: 'view' | 'download' | 'send', attachment: Attachment, receiver?: string) => void;
}
export const QuestionnaireContract: FC<Props> = ({ attachments, operationId, emailReceiver, ...props }) => {
  const contract = attachments?.find((attachment) => attachment.fileName?.startsWith('vertrag_'));
  return (
    <QuestionnaireForm title={'Vertrag abschließen'}>
      {
        contract &&
        <QuestionnaireDocumentDownload
          attachment={contract}
          operationId={operationId}
          emailReceiver={emailReceiver}
          onDocumentAction={props.onDocumentAction}
        />
      }
    </QuestionnaireForm>
  )
}
